import api from './api';
import BaseFinancialService, { handleApiError } from './financialService';

class DespesaService extends BaseFinancialService {
  constructor() {
    super('/financeiro/despesas');
  }

  // Métodos específicos de despesas
  
  async getStats(mes = null, ano = null) {
    try {
      const params = {};
      if (mes) params.mes = mes;
      if (ano) params.ano = ano;
      
      const response = await api.get(`${this.endpoint}/stats/geral`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar estatísticas de despesas');
    }
  }

  async getAlertasVencendo(dias = 7) {
    try {
      const response = await api.get(`${this.endpoint}/alertas/vencendo`, {
        params: { dias }
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar despesas vencendo');
    }
  }

  async getAtrasadas() {
    try {
      const response = await api.get(`${this.endpoint}/alertas/atrasadas`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar despesas atrasadas');
    }
  }

  async getRecorrentes(ativas = null) {
    try {
      const params = {};
      if (ativas !== null) params.ativas = ativas;
      
      const response = await api.get(`${this.endpoint}/recorrentes/lista`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar despesas recorrentes');
    }
  }

  async registrarPagamento(despesaId, pagamentoData) {
    try {
      const response = await api.post(`${this.endpoint}/${despesaId}/pagamento`, pagamentoData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao registrar pagamento');
    }
  }

  async toggleRecorrencia(despesaId, ativar) {
    try {
      const response = await api.put(`${this.endpoint}/${despesaId}/recorrencia/toggle`, null, {
        params: { ativar }
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao alterar recorrência');
    }
  }

  async uploadAnexo(despesaId, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post(
        `${this.endpoint}/${despesaId}/anexos/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao fazer upload do anexo');
    }
  }

  async deleteAnexo(despesaId, anexoId) {
    try {
      const response = await api.delete(`${this.endpoint}/${despesaId}/anexos/${anexoId}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao deletar anexo');
    }
  }
}

export default new DespesaService();
